<template>
	<div class="content">
		<h1>Balance refresh failures</h1>

		<p class="margin-top border-black padding">
			Orders the balance refresh job could not recompute. Each is retried
			later with a growing wait (1 hour, 4 hours, 1 day, then weekly).
			Fix the order, then use <em class="bold">Refresh now</em>; a successful refresh
			clears the hold. <em>Give up</em> stops the retries for an order
			that cannot be fixed; <em>Resume</em> puts it back.
		</p>

		<Loader v-if="soft_loading" :soft="true" />

		<p v-if="!records.length" class="margin-top">No orders are held back.</p>

		<Table v-else class="margin-top" :columns="columns" :rows="records" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    soft_loading: false,
    records: [],
    columns: {
      order: {
        name: 'Order'
      },
      status: {
        name: 'Status'
      },
      failed_attempts: {
        name: 'Failures'
      },
      last_failed_at: {
        name: 'Last failed'
      },
      next_attempt_at: {
        name: 'Next attempt'
      },
      last_error: {
        name: 'Last error'
      }
    }
  }),
  methods: {
    load () {
      Vue.$api.get('/order-balances/failures', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: data => this.parse(data)
      })
    },
    refresh (orderId) {
      this.act(orderId, 'refresh')
    },
    giveUp (orderId) {
      this.act(orderId, 'give-up')
    },
    resume (orderId) {
      this.act(orderId, 'resume')
    },
    act (orderId, action) {
      Vue.$api.post('/order/' + orderId + '/balance/' + action, {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.load()
      })
    },
    statusOf (row) {
      if (row.refresh_ignored_at) {
        return 'Given up ' + row.refresh_ignored_at
      }
      if (row.next_attempt_at && new Date(row.next_attempt_at) > new Date()) {
        return 'Held until ' + row.next_attempt_at
      }
      return 'Due for retry'
    },
    parse (data) {
      this.records = data.map(row => {
        if (row.last_error && row.last_error.length > 160) {
          row.last_error = row.last_error.substring(0, 160) + '…'
        }

        row.order = {
          type: 'order-link',
          order_id: row.id
        }

        row.status = this.statusOf(row)

        row.menu = [
          {
            name: 'Refresh now',
            onClick: row => {
              this.refresh(row.id)
            }
          },
          row.refresh_ignored_at
            ? {
              name: 'Resume',
              onClick: row => {
                this.resume(row.id)
              }
            }
            : {
              name: 'Give up',
              onClick: row => {
                this.giveUp(row.id)
              }
            }
        ]

        return row
      })
    }
  },
  created () {
    this.load()

    Vue.$ui.setTitle('Balance refresh failures')
  }
}
</script>
